import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ListView from './views/ListView';
import { CreateForm, EditForm } from './views/FormView';
import useApi from '../../api';
import BaseLayout from '../../components/CabinetBaseLayout';

const Component = () => {
  const api = useApi();
  const router = api.router.managers;
  return (
    <BaseLayout>
      <Switch>
        <Route exact path={router.list()} component={ListView} />
        <Route exact path={router.create()} component={CreateForm} />
        <Route path={router.edit(':id')} component={EditForm} />
      </Switch>
    </BaseLayout>
  );
};

export default Component;
